import React from "react";

export enum ButtonType {
    CTABUTTON = "CTABUTTON",
    TEXTICONLINK = "TEXTICONLINK"
}

export default interface ButtonProps {
    label?: string;
    title?: string;
    href?: string;
    target?: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}
